export default __webpack_public_path__ + "static/media/avatar.63dc8c41.jpg";